import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FancastComponent } from './components/fancast/fancast.component';
import { PickscoreComponent } from './components/pickscore/pickscore.component';
import { DrawingcontestComponent } from './components/drawingcontest/drawingcontest.component';
import { FilmcontestComponent } from './components/filmcontest/filmcontest.component';
import { AllcontestComponent } from './components/allcontest/allcontest.component';
import { DrawingReceiptComponent } from './components/drawing-receipt/drawing-receipt.component';
import { DrawingmainComponent } from './components/drawingmain/drawingmain.component';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';

const routes: Routes = [
  {
    path: 'film',
    component:FilmcontestComponent,
  },
  {
    path: 'all-contest',
    component:AllcontestComponent,
  },
  {
    path: 'drawings',
    component: DrawingmainComponent,
  },
  {
    path:':id',
    component:PickscoreComponent,
    canActivate: [AuthGuard]
  },
  {
    path:':type/:id/:name',
    component:PickscoreComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'drawings/:id',
    component:DrawingcontestComponent,
  },
  {
    path:'charge/drawing/:id',
    component:DrawingReceiptComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContestanddrawingRoutingModule { }
